import Head from 'next/head'
import isStaging from '@/lib/isStaging'

export default function CustomHead() {
  return (
    <Head>
      <meta charSet="utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=Edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="format-detection" content="telephone=no" />
      {isStaging() && <meta key="robots" name="robots" content="noindex, nofollow" />}
      <link rel="shortcut icon" href="/favicon.ico" />
      <meta name="theme-color" content="#13539e" />
      <meta name="msapplication-TileColor" content="#f3f4f7" />
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="manifest" href="/site.webmanifest" />
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#13539e" />
      <meta name="facebook-domain-verification" content="5ll2yrnaf1dh97q6z8k68hw1vch961" />

      <title>Elemental Day Surgical Center</title>

      <meta key="og:site_name" property="og:site_name" content="elemental.ae" />
      <meta key="og:type" property="og:type" content="website" />
    </Head>
  )
}
